import { render } from "./LocaleList.vue?vue&type=template&id=74ed80df"
import script from "./LocaleList.vue?vue&type=script&lang=js"
export * from "./LocaleList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__